"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.write = exports.readAccessToken = exports.read = exports.clear = exports.shouldForceSsoLoginAccessToken = void 0;
var decode_1 = __importDefault(require("../encoders/user/decode"));
var storageFieldName = ['LRTokenKey', 'mona-sdk_accessToken'];
var storageFieldNameUser = 'mona-sdk_user';
var shouldForceSsoLoginAccessToken = function () { return Promise.resolve(undefined); };
exports.shouldForceSsoLoginAccessToken = shouldForceSsoLoginAccessToken;
var clear = function () {
    for (var _i = 0, storageFieldName_1 = storageFieldName; _i < storageFieldName_1.length; _i++) {
        var storageFieldNameValue = storageFieldName_1[_i];
        global.localStorage.removeItem(storageFieldNameValue);
        global.sessionStorage.removeItem(storageFieldNameValue);
    }
    global.localStorage.removeItem(storageFieldNameUser);
};
exports.clear = clear;
var read = function () {
    var lsAccessToken = global.localStorage.getItem(storageFieldName[0]);
    var lsUser = global.localStorage.getItem(storageFieldNameUser);
    try {
        if (lsAccessToken && lsUser) {
            var lsUserAsJSON = JSON.parse(lsUser);
            return {
                user: (0, decode_1.default)(lsUserAsJSON),
                accessToken: lsAccessToken,
            };
        }
    }
    catch (e) {
        (0, exports.clear)();
    }
    // If no accessToken or error during user parsing
    // empty AuthPayload is returned
    return {
        user: undefined,
        accessToken: undefined,
    };
};
exports.read = read;
var readAccessToken = function () {
    var _a;
    return (_a = global.localStorage.getItem(storageFieldName[0])) !== null && _a !== void 0 ? _a : undefined;
};
exports.readAccessToken = readAccessToken;
var write = function (authPayload) {
    for (var _i = 0, storageFieldName_2 = storageFieldName; _i < storageFieldName_2.length; _i++) {
        var storageFieldNameValue = storageFieldName_2[_i];
        global.localStorage.setItem(storageFieldNameValue, authPayload.accessToken);
        global.sessionStorage.setItem(storageFieldNameValue, authPayload.accessToken);
    }
    global.localStorage.setItem(storageFieldNameUser, JSON.stringify(authPayload.user));
};
exports.write = write;
